// Per-browser "last viewed report" for the Reports v2 shell, scoped by user
// AND business location so switching either never reopens someone else's (or
// another location's) report. Mirrors utils/terminalPreference.ts: every
// localStorage access is wrapped, since storage can be unavailable (private
// mode, blocked site data, quota) and the page must still work without it.

const STORAGE_PREFIX = "pagoda.reports.lastViewed.";

const keyFor = (userId: string, businessLocationId: string): string =>
  `${STORAGE_PREFIX}${userId}.${businessLocationId}`;

export const getLastViewedReportId = (
  userId: string | null | undefined,
  businessLocationId: string | null | undefined,
): string | null => {
  if (typeof window === "undefined" || !userId || !businessLocationId) {
    return null;
  }
  try {
    return localStorage.getItem(keyFor(userId, businessLocationId));
  } catch {
    return null;
  }
};

export const setLastViewedReportId = (
  userId: string | null | undefined,
  businessLocationId: string | null | undefined,
  reportId: string,
): void => {
  if (typeof window === "undefined" || !userId || !businessLocationId) return;
  try {
    localStorage.setItem(keyFor(userId, businessLocationId), reportId);
  } catch {
    /* ignore localStorage errors (private mode, quota) */
  }
};
